import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { CityService } from '../../../../services/city.service';
import { CityModel } from '../../../../models/city.model';
import { MkmService } from '../../../../services/mkm.service';
import { NgForOf, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { RouterModule } from '@angular/router';

@Component({
    standalone:true,
    imports:[FormsModule,NgIf,NgForOf,MatTableModule,MatPaginatorModule,RouterModule],
    providers:[MkmService,CityService],
    selector: 'city-index',
    templateUrl: './city-index.component.html',
    styleUrls: ['./city-index.component.css']
})
export class CityIndexComponent implements AfterViewInit,OnInit {
    filter: string;
    allCitys!: CityModel[];
    citys!: CityModel[];
    displayedColumns: string[] = ['שטאט', 'city', 'לאנד', 'actions'];
    dataSource = new MatTableDataSource<CityModel>();
    @ViewChild(MatPaginator) paginator: MatPaginator;
    constructor(private cityService: CityService, private mkmService: MkmService) {}

    ngOnInit(): void {

        this.cityService.getCitys().subscribe(c => {
            this.citys = this.allCitys = c;
            this.dataSource.data = this.citys;
        });
      this.onSearch(); 
    }
    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
      }
    onDelete(id: number) {


        this.mkmService.getMkmCityId(id).subscribe(m => {

            if (m.length) {

                alert("Can't delete city with poi attached");
                return;
            }
            if (confirm("Are you sure?")) {
                this.cityService.delete(id).subscribe(s => {
                    var i = this.citys.findIndex(function (c) {
                        return c.id == id;
                    });

                    this.citys.splice(i, 1);
                });
            }
        });
    }
    onSearch() {
        var citys = this.allCitys;
   
        if (this.filter) {
            citys = citys.filter(s => s.cityY.includes(this.filter)
                || s.cityE.includes(this.filter)
                || s.cityE.toLowerCase().includes(this.filter)
                || s.cityE.toUpperCase().includes(this.filter)
                || s.state.stateY.includes(this.filter));
        }
        this.dataSource.data = citys;
    }
}
